﻿var core = require('./core.js');

$(document).ready(function () {
    $('#gototop').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
    var core = require('./core.js');

    var resp = core.urlToObj(false);
    if (resp == null) {
        history.pushState('', 'title', "?PageSize=10&Sort=0&PageNumber=1");
        var resp = core.urlToObj(false)
    }
    getListOrg(resp);

    setControlforReestrListform();
    var setObj = core.urlToObj(true);
    for (let item in setObj) {
        var Tobj = {};
        Tobj[item] = setObj[item];
        setVaribleElemToCntrl('collapse_search_panel__form', Tobj);
    }
});

// получить список поставщикоа
function getListOrg(sendObj) {
    core.sentAjaxTo('GetListChildren', sendObj);
}

// отрисовать грид
export function setDataListOrg(resp) {
    drawfirst(resp);
}


var drawfirst = function (data1) {

    $('.treatmet-pager').PagerPlugins({
        totalRows: data1.count,
        sendMethodCaption: "./ASPWebDataServise.asmx/GetListChildren",
        sendMethodObj: core.urlToObj(false)
    },
        {
            show: function (data1) {
                draw(data1)
            }
        }
    )
    draw(data1)
    $('#allPage').html();
    let pagecount = Math.ceil(data1.count / $('.form-free').length);
    $('#allPage').html('Детей по списку: ' + data1.count + '<br> Всего страниц: ' + pagecount);
   
}

var draw = function (resp) {
    let objArr = resp.listChild;
    let text = '';
    core.startLoadingAnimation();
    objArr.forEach((value) => {
        text += '<div class="form-free">';
        text += '<dl class="row"><div class="col-3"><img class="form_easy_search img-fluid img-rounded" style="min-height:300px" id="ItemPreview" src="' + (value.photo != null ? "data:image/png;base64," + value.photo : "./images/logo_3.jpg") + '" /></div><div class="col-9">';
        text += '<dl class="row row-free_" > <dt class="col-12 col-sm-4">Имя</dt> <dd class="col-12 col-sm-8">' + value.imja + '</dd></dl > ';
        text += '<dl class="row row-free_"><dt class="col-12 col-sm-4">Год рождения</dt><dd class="col-12 col-sm-8">' + value.birthyear + '</dd></dl>';
        text += '<dl class="row row-free_"><dt class="col-sm-4">Пол</dt><dd class="col-sm-8">' + value.pol + ' </dd></dl> ';
        text += '<dl class="row row-free_"><dt class="col-sm-4">Национальность</dt><dd class="col-sm-8">' + checkLink('ethnic', value.ethnic) + '</dd></dl>';
        text += '<dl class="row row-free_"><dt class="col-sm-4">Цвет глаз</dt><dd class="col-sm-8">' + value.eyescolor + '</dd></dl>';
        text += '<dl class="row row-free_"> <dt class="col-sm-4">Приметы</dt><dd class="col-sm-8"> ' + value.primet + '</dd></dl>';
        text += '<dl class="row row-free_"> <dt class="col-sm-4">Братья и сестры</dt><dd class="col-sm-8" id="link' + value.id + '"> ' + checkBrSist(value.br_sist, value.br_link, value.id) + '</dd></dl>';
        text += '<dl class="row row-free_"> <dt class="col-sm-4">Особенности</dt><dd class="col-sm-8"> ' + checkLink('osoben', value.osoben) + '</dd></dl>';
        text += '<dl class="row row-free_"> <dt class="col-sm-4">Форма устройства</dt><dd class="col-sm-8"> ' + value.possibleforms + '</dd></dl>';
        text += '<dl class="row row-free_"> <dt class="col-sm-4">Дополнительная информация</dt><dd class="col-sm-8"> ' + checkLink('dopinfo', value.dopinfo) + '</dd></dl>';
        text += '</div> ';
        text += '</div> ';
    })

    $('.reestr__containerr').html(text);
    //createPagerControl(resp.count);

    core.stoptLoadingAnimation();
};


function checkBrSist(br_sist_text, br_link, id_link) {
    if (br_link != -1) {
        let sendObj = {};
        sendObj.id = br_link;
        sendObj.id_link = id_link;
        core.sentAjaxTo('CheckChildInList', sendObj);
        return '';
    }
    else {
        return br_sist_text;
    }
}

export function setResultInfo(resp) {
    resp.forEach((value, index, resp) => {
        if (value.link ==='True')
            $('#link' + value.id_link).append('<a href="./info.html?id=' + value.ID + '">' + value.IMJA + ', ' + value.BIRTHYEAR + ' г.р.</a>');
        else
            $('#link' + value.id_link).append(value.IMJA + ', ' + value.BIRTHYEAR + ' г.р.');

    }) 
}

function checkLink(key, val) {
    if (key === "dopinfo" || key === "osoben") {
        var queryStart = val.indexOf("http"),
            queryEnd = val.length + 1,
            query = val.slice(queryStart, queryEnd - 1),
            link = '<a href=' + query + ' target="_blank">Посмотреть<a/>';
        var str = val.slice(0, queryStart);
        var val = (query.length > 1 ? str + " " + link : str);
    }
    else {
        val = (val == null ? '' : val);
    }
    return val
}


///////////////////////////////// Грид /////////////////////////////////

// обработчик нажатия кнопки выбора вида сорировки
export function SetValuePsort(id) {
    var obj = {
        PageNumber:'1',
        PageSize: $('.page-count-rows__btn-info').val(),   
        Sort: id.replace('_sd', '')
    }

    getListOrg(obj);
    $('.page-sort-rows__btn-info').text($('#' + id).text());
}

//изменение параметров поиска данных из url
function setSearchParam(arrObj) {
    var searchstr = location.search.split('&');
    searchstr[0] = searchstr[0].substr(1);
    var rezult = '';
    for (var j = 0; j < arrObj.length; ++j) {
        var item = arrObj[j];
        for (var i = 0; i < searchstr.length; ++i)
            if (searchstr[i].search(item.k) == 0)
                searchstr[i] = "";
    }
    for (var i = 0; i < searchstr.length; ++i)
        if (searchstr[i] != "")
            rezult += '&' + searchstr[i];
    for (var j = 0; j < arrObj.length; ++j) {
        var item = arrObj[j];
        rezult += '&' + item.k + '=' + item.v;
    }
    rezult = '?' + rezult.substr(1);
    return rezult;
}


///////////////////////////////// Контролы /////////////////////////////////
//инициализация контролов 
function setControlforReestrListform() {
    $('#haircolor').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('haircolor', term))
        }
    });

    $('#eyescolor').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('eyescolor', term))
        }
    });
    $('#possibleforms').mSelect({
        tokensMaxItems: 1,
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('possibleforms', term))
        }
    });
    $('#pol').mSelect({
        tokensMaxItems: 1,
        placeholder: 'начните ввод...',
        dataSource: 'select',
        searchFromStart: false
    });
    $('#br_sist').mSelect({
        tokensMaxItems: 1,
        placeholder: 'начните ввод...',
        dataSource: 'select',
        searchFromStart: false
    });
    $('#drog').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('drog', term))
        }
    });
}

function setVaribleElemToCntrl(formCaption, setObj) {
    for (let iemObj in setObj) {
        if (typeof (setObj[iemObj]) === 'object') {

            let key = null;
            let value = null;

            var arrObjtoCntrl = setObj[iemObj];

            if ("length" in arrObjtoCntrl) {
                for (let data in arrObjtoCntrl) {
                    if (arrObjtoCntrl[data]) {
                        key = (arrObjtoCntrl[data].k ? arrObjtoCntrl[data].k : arrObjtoCntrl[data].id);
                        value = (arrObjtoCntrl[data].v ? arrObjtoCntrl[data].v : arrObjtoCntrl[data].name);

                        if ($('#' + formCaption).find('[name = ' + iemObj + ']').length > 0)
                            $('#' + formCaption).find('[name = ' + iemObj + ']').mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                        else
                            if ($('#' + formCaption).find('#' + iemObj).length > 0)
                                $('#' + formCaption).find('#' + iemObj).mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                    }
                }
            }
            else {
                let key = arrObjtoCntrl.k;
                let value = arrObjtoCntrl.v;

                if ($('#' + formCaption).find('[name = ' + iemObj + ']').length > 0)
                    $('#' + formCaption).find('[name = ' + iemObj + ']').mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                else
                    if ($('#' + formCaption).find('#' + iemObj).length > 0)
                        $('#' + formCaption).find('#' + iemObj).mSelect().trigger('tokenize:tokens:add', [key, value, true]);
            }
        }
        else {
            $('#' + formCaption).find('[name = ' + iemObj + ']').val(setObj[iemObj]);
        }
    }
}

// выделяет обьекты с множественным выбором 
// outputs {key:["param", "param"]}
function setDataMulticontrol(iArr, rezObj) {
    let iArrKey = Object.keys(rezObj);
    let data = {};
    $.each(iArrKey, (indexKey, valueKey) => {
        let TArr = [];
        $.each(iArr, (index, val) => {
            let name = val.name;
            if (name.indexOf(valueKey) > -1) {
                let Tval = val.value;
                TArr.push(Tval);
            }
        })
        if (TArr.length > 1)
            data[valueKey] = TArr;

    })
    return data;
}

// param - параметр запроса
function setDataControl(lookupTable, param) {
    var data = {};
    if (lookupTable != null && lookupTable != '') {
        data.lookupTable = lookupTable;
    }
    data.name = param;
    return JSON.stringify(data);
}

function setAjaxRequest(term, object, dataToJSON) {
    $.ajax({
        type: "Post",
        url: "./ASPWebDataServise.asmx/GetLookupTable",
        data: "{inputsParam:'" + dataToJSON + "'}",
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            let data = JSON.parse(response.d);
            var $items = [];
            $.each(data, function (k, v) {
                $items.push(v);
            });
            object.trigger('tokenize:dropdown:fill', [$items]);
        }
    });
}

//очистка панели поиска 
function clear(formCaption) {
    let $arr = $('#' + formCaption).find('select');
    $arr.each((index, element) => {
        let id = element.id;
        $('#' + formCaption).find('#' + id).mSelect().trigger('tokenize:clear');
    })

    $('#' + formCaption).find('input').val('');
}

///////////////////////////////// обработчики кнопок /////////////////////////////////
// обработчик нажатия кнопки найти
export function searchAndCreateData(formCaption) {
    core.dataFormToURL(formCaption); // параметры формы to url
    let data = core.urlToObj(false);
    getListOrg(data);
}

//кнопка очистки 
export function clearSearchPanel() {
    history.pushState('', 'title', "?PageSize=10&Sort=0&PageNumber=1");
    let resp = core.urlToObj(false);
    getListOrg(resp);
    clear('collapse_search_panel__form');
}


//////////////////
// WEBPACK FOOTER
// ./js/main.js
// module id = 1
// module chunks = 0 1 2